"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Button, Card, CardContent, CardHeader } from "@saridana-core/react-ui-kit";
import { ContactFormSubmitType, TFormField } from "@shared/types";
import { DynamicForm } from "@shared/ui";

type Props = {
  fields: TFormField[];
  buttonText: string;
  submitType: ContactFormSubmitType;
};

export function ContactForm({ fields, buttonText, submitType }: Props) {
  const config = useClientConfig();
  const whatsappManager = config?.layoutSettings?.attributes?.features?.whatsappManager;

  const handleSubmit = (values: any) => {
    if (values) {
      switch (submitType) {
        case "whatsapp":
          const whatsappMessage = `Halo BPR Saridana,%0A%0ASaya ingin mengajukan pertanyaan melalui formulir kontak.%0A%0ANama: ${encodeURIComponent(values.name)}%0ANomor Telepon: ${encodeURIComponent(values.phone)}%0AEmail: ${values.email}${
            values.message ? `%0A%0APesan: ${encodeURIComponent(values.message)}` : ""
          }%0A%0ATerima Kasih. `;

          window.open(`${whatsappManager?.link}?text=${whatsappMessage}`, "_blank", "noopener,noreferrer");
          break;
      }
    }
  };

  return (
    <Card className="w-full rounded-2xl">
      <CardContent className="h-auto px-6 py-6 md:px-9 md:py-10">
        <DynamicForm
          fields={fields}
          defaultValues={fields.reduce((obj: any, item) => {
            obj[item.name] = "";
            return obj;
          }, {})}
          onSubmit={handleSubmit}
        >
          <Button type="submit" className="text-lg md:text-xl h-14 md:h-[60px] md:px-8 w-full rounded-xl py-4 px-6 font-bold">
            {buttonText}
          </Button>
        </DynamicForm>
      </CardContent>
    </Card>
  );
}
